import styled from 'styled-components';

export const FeaturedArea = styled.div`
  grid-area: ft;
`;

export const ShareLayout = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  gap: 12px;

  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
`;

export const ShareMain = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  border-radius: 12px;
  overflow: hidden;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.08);

  > * {
    width: 100%;
    height: 100%;
  }
`;

export const ShareFilmstrip = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 220px;
  min-width: 220px;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 2px;

  @media screen and (max-width: 900px) {
    flex-direction: row;
    width: auto;
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    padding-right: 0;
    padding-bottom: 2px;
  }
`;

export const ShareFilmstripTile = styled.div`
  width: 220px;
  min-width: 220px;
  height: 124px;
  border-radius: 12px;
  overflow: hidden;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.12);
  position: relative;
  flex-shrink: 0;

  > * {
    width: 100%;
    height: 100%;
  }
`;

export const ShareFilmstripPlaceholder = styled(ShareFilmstripTile)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-style: dashed;
  background: rgba(255, 255, 255, 0.025);
  color: #9fb0c2;
  font-size: 13px;
  line-height: 1.4;
  text-align: center;
`;

export const ContentShareGrid = styled.div`
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: 1fr;
  gap: 4px;
  width: 100%;
  height: 100%;
`;

export const TileSurface = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const MainCardNameChip = styled.div`
  position: absolute;
  left: 10px;
  bottom: 10px;
  background: rgba(7, 23, 36, 0.42);
  backdrop-filter: blur(8px);
  border-radius: 999px;
  color: #fff;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
`;

export const PresenterPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  color: #fff;
  background: linear-gradient(180deg, #0f2232 0%, #1a3a50 100%);
`;
